import type { ReactNode } from 'react';
import { Link } from 'react-router';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title: string;
  /** Plain text, or a node when a screen wants a quiet link alongside it. */
  subtitle?: ReactNode;
  backTo?: string;
  /** Tighter, for screens where vertical space belongs to the content. */
  compact?: boolean;
}

export function PageHeader({ title, subtitle, backTo = '/', compact = false }: PageHeaderProps) {
  return (
    <header className={[styles.header, compact ? styles.compact : ''].filter(Boolean).join(' ')}>
      <Link to={backTo} className={styles.back} aria-label="Back">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
      </Link>
      <div className={styles.titles}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
    </header>
  );
}
